import imsc from "./imsc.png";

function About() {

    return (
        <div style={{margin: '16px'}}>
            
            <h2>Publications</h2>
            <ul>
                <li>
                    Chrysovalantis Anastasiou, Seon Ho Kim, Cyrus Shahabi.&nbsp;
                    <strong>Generation of Synthetic Urban Vehicle Trajectories</strong>.&nbsp;
                    IEEE International Conference on Big Data (BigData 2022), Dec. 2022.&nbsp;
                    <a href="https://ieeexplore.ieee.org/abstract/document/10020237/" target="_blank" rel="noreferrer">link</a>
                </li>
                <li>
                    Chrysovalantis Anastasiou, Juanhao Zhao, Seon Ho Kim, Cyrus Shahabi.&nbsp;
                    <strong>Data-driven Traffic Index from Sparse and Incomplete Data</strong>.&nbsp;
                    IEEE 25th International Conference on Intelligent Transportation Systems (ITSC), 2022.&nbsp;
                    <a href="https://ieeexplore.ieee.org/abstract/document/9922116" target="_blank" rel="noreferrer">link</a>
                </li>
            </ul>

            <a href="https://imsc.usc.edu" target="_blank" rel="noreferrer">
            <img src={imsc} alt="" width={250} />
            </a>
        </div>
    );
}

export default About;
